module.exports = __webpack_public_path__ + "img/tanyue.99f0895f.jpg";